var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.429 2.571c-0.4714 0-0.8571 0.3857-0.8571 0.8571v17.14c0 0.4714 0.3857 0.8571 0.8571 0.8571h17.14c0.4714 0 0.8571-0.3857 0.8571-0.8571v-17.14c0-0.4714-0.3857-0.8571-0.8571-0.8571zm-3.429 0.8571c0-1.891 1.538-3.429 3.429-3.429h17.14c1.891 0 3.429 1.538 3.429 3.429v17.14c0 1.891-1.538 3.429-3.429 3.429h-17.14c-1.891 0-3.429-1.538-3.429-3.429zm18.05 6.054-6.857 6.857c-0.5036 0.5036-1.318 0.5036-1.816 0l-3.429-3.429c-0.5036-0.5036-0.5036-1.318 0-1.816 0.5036-0.4982 1.318-0.5036 1.816 0l2.518 2.518 5.946-5.952c0.5036-0.5036 1.318-0.5036 1.816 0 0.4982 0.5036 0.5036 1.318 0 1.816z",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutline);
export default __webpack_public_path__ + "static/media/check-outline.baa36139b5717cd784770c08db45552d.svg";
export { ForwardRef as ReactComponent };